<template>
    <div>
      <div class="row">
        <div class="col-6">
          <i class="ml-2 bi bi-question-circle-fill" data-toogle="tooltip" title="Treemap is representative of numbers of reads for taxon selected and sub-taxonomy, this is a navigable plot"
             v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover></i>
        </div>
        <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
          <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
             v-bind:style="{ fontSize : '15px'}"></i>
          <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
          <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
             v-b-modal="componentId+'-modal-save'"></i>
          <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
             v-bind:style="{ fontSize : '12px'}"></i>
        </div>
      </div>
        <div class="widget-legend legend">
            <span>Richness by asv on {{ fraction }} µm at depth {{ depth }}</span>
        </div>

        <TreemapWidget :plotData="plotData" :componentId="componentId">
        </TreemapWidget>
        <div>
            <b-modal :id="componentId+'-modal'" title="Richness by asv">
                <div class="form-group mt-2" style="font-size: 1.6vmin;">
                    <template>
                        <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group
                                    :id="componentId+'radio-group-2'"
                                    v-model="fraction"
                                    :options="fractions"
                                    :aria-describedby="ariaDescribedby"
                                    name="fraction-options"
                            ></b-form-radio-group>
                        </b-form-group>
                    </template>
                </div>
                <div class="form-group mt-2">
                    <b-form-group label="Depth">
                        <select v-model="depth" class="form-control">
                            <option v-for="option in depthCodes" v-bind:key="option.depth" :value="option.depth">
                                {{ option.depth }}
                            </option>
                        </select>
                    </b-form-group>
                </div>
            </b-modal>
        </div>
        <b-modal :id="componentId+'-legend'" title="Legend">
            HTML allowed
            <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

            <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
        </b-modal>
        <ExportDialog :componentId="componentId" :plotData="plotData" :exportFileName="exportFileName"
                      :dataset="dataset" :legend="legend"></ExportDialog>
        <div>
            <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
                <b-card>
                    <div v-html="legend">
                    </div>

                </b-card>
            </b-collapse>
        </div>

    </div>
</template>

<script>
import TreemapWidget from "./TreemapWidget";
import axios from "axios";
import {mapActions} from "vuex";
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";

export default {
  name: "TreemapGraph",
  props: ['panelId', 'componentId', 'triggerValue', 'settings'],
  mixins:[ApiCall],
  components: {
    TreemapWidget,
    ExportDialog
  },
  data() {
    return {
      dataset: null,

            rank: null,
            searchPanelTaxon: null,

            dateStart: null,
            dateEnd: null,
            date: [],
            legend: null,
            asv: null,

            fractions: [],
            fraction: null,
            depthCodes: {},
            depth: null,
            visible:false,
            plotData: null,

            settings_hash: "",
            exportFileName: "default_treemap_name",
            apiCallsInProgress: 0,
        }
    },
    watch: {
        triggerValue() {
            this.updateContents()
        },
        fraction() {
            this.getPlotData()
        },
        depth() {
            this.getPlotData()
        },
        legend() {
            this.updateDashboardWidgetLegend({
                'componentId': this.componentId,
                'legend': this.legend
            })
        }
    },
    created() {
        this.updateContents()
    },

    methods: {

        ...mapActions([
            'updateDashboardWidgetSettings',
            'cloneWidget',
            'updateDashboardWidgetLegend'
        ]),


        updateContents() {
            let panel = this.$store.state.panels[this.panelId]

            let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
            if (newPanelSettingsHash === this.settingspanelHash) {
                return
            }
            this.settingspanelHash = newPanelSettingsHash
            this.plotData = null
            this.dataset = panel.dataset
            this.rank = panel.rank
            this.searchPanelTaxon = panel.taxon
            this.dateStart = panel.dateStart
            this.dateEnd = panel.dateEnd

            this.initializeDateList()
            this.initializeLegend()
            this.initializeDepthCode()

        },


        getPlotData() {
            if (this.apiCallsInProgress > 0) {
                setTimeout(this.getPlotData, 2000)
                return
            }
            if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.searchPanelTaxon && this.depth) {

                let newSettingsHash = this.dataset + this.searchPanelTaxon + this.rank + this.fraction + this.dateStart + this.dateEnd + this.depth
                if (newSettingsHash === this.settings_hash) {
                    return
                }

                this.settings_hash = newSettingsHash
                this.plotData = null
                this.updateDashboardWidgetSettings({
                    'componentId': this.componentId,
                    'settings': {
                        'dataset': this.dataset,
                        'taxon': this.searchPanelTaxon,
                        'fraction': this.fraction,
                        'dateStart': this.dateStart,
                        'dateEnd': this.dateEnd,
                        'depth': this.depth,
                        'legend': this.legend
                    }
                })

                let me = this

                axios
                    .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['nested_abundances_taxon',
                    this.dataset, this.rank, this.searchPanelTaxon, this.fraction, this.dateStart, this.dateEnd, this.depth]))
                    .then(function (response) {
                        me.plotData = response.data
                    })
            } else {
                console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
            }
        },

    initializeDateList() {
      if (this.dataset && this.dateStart && this.dateEnd) {
        let me = this
        me.apiCallsInProgress++
          axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['date_list', this.dataset, this.dateStart,
            this.dateEnd]))
            .then(function (response) {
              if (response.data) {
                me.date = response.data
                if (me.settings['restore']) {
                  me.dateSelected = me.settings['dateSelected']
                } else {
                  me.dateSelected = response.data[0]
                }
              }
              me.initializeFractionSizes()
              me.getPlotData()
            })
        me.apiCallsInProgress--
      } else {
        console.warn("No date initialization performed.")
      }
    },
  }
}
</script>

<style scoped>

</style>